<template>
  <div id="create-user">
    <a-tabs style="border: 1px solid #d9d9d9; border-radius: 6px;">
      <a-tab-pane key="depot" tab="Depot" class="a-tab-pane">
        <depot-tab
          :AWS="AWS"
          :masterCompanyMap="masterCompanyMap"
          :cognitoidentityserviceprovider="cognitoidentityserviceprovider"
          ref="depotTab"
        />
      </a-tab-pane>
      <a-tab-pane key="fleet" tab="Fleet" class="a-tab-pane">
        <fleet-tab :AWS="AWS" ref="fleetTab" />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import { mapState } from "vuex";
import FleetTab from "./Fleet/index.vue";
import DepotTab from "./Depot/index.vue";
export default {
  data() {
    return {
      AWS: require("aws-sdk"),
      cognitoidentityserviceprovider: null,
      masterCompanyMap: new Map()
    };
  },
  components: {
    FleetTab,
    DepotTab
  },

  computed: {
    ...mapState(["PoolData", "IdToken", "IdentityPoolData", "CompanyMap"])
  },

  methods: {
    async getMasterCompanyList() {
      var params = {
        objectType: "MCL",
        operation: "get",
        region: "us-west-2"
      };
      try {
        let dataArray = await this.sendRequest(params);
        let data = dataArray.flat(Infinity);
        // check if no data is returned; display a message to user in that case.
        if (!data.length) {
          throw new Error("No master company list found!");
        }
        var companyList = data[0].listOfCompanies;
        var companyMap = new Map();
        companyList.forEach(companyObject => {
          companyMap.set(companyObject.company, {
            depots: companyObject.depots,
            fleets: companyObject.fleets,
            region: companyObject.region,
            hasTransformer: companyObject.hasTransformer
          });
        });
        this.masterCompanyMap = companyMap;
      } catch (error) {
        this.$message.error("Error retrieving MasterCompanyList: " + (error.message ? error.message : error));
        return;
      }
    },

    sendRequest(params) {
      // before making an API request, check to make sure user has access to perform the action / credentials need to be refreshed.
      return new Promise((resolve, reject) => {
        this.AWS.config.credentials.clearCachedId();
        this.AWS.config.credentials.get(async credentialError => {
          if (credentialError) {
            if (credentialError.name === "NotAuthorizedException") {
              reject(
                new Error(
                  "You are not authorized to perform this action. Please contact Support Team if you think this is a mistake."
                )
              );
            } else {
              reject(credentialError.message);
            }
          } else {
            try {
              const aws4 = require("aws4");
              let paramsUrl = this.createParamsUrl(params);
              let request = {
                host: "v9ovun9ana.execute-api.us-west-2.amazonaws.com",
                method: "GET",
                url: "https://v9ovun9ana.execute-api.us-west-2.amazonaws.com/prod/configure?" + paramsUrl,
                path: "/prod/configure?" + paramsUrl,
                service: "execute-api"
              };
              let signedRequest = aws4.sign(request, {
                secretAccessKey: this.AWS.config.credentials.secretAccessKey,
                accessKeyId: this.AWS.config.credentials.accessKeyId,
                sessionToken: this.AWS.config.credentials.sessionToken
              });
              // delete unsafe headers from the signed request.
              delete signedRequest.headers["Host"];
              delete signedRequest.headers["Content-Length"];

              let response = await this.$axios(signedRequest);
              let items = response.data.Items;
              resolve(items);
            } catch (error) {
              // if no response is available, means it is a network error.
              if (!error.response) {
                reject(new Error("Network Error. Please try again!"));
              } else {
                let response = error.response;
                if (response.status == 403) {
                  reject(
                    "You are not authorized to perform this action. Please contact Support Team if you think this is a mistake."
                  );
                } else {
                  reject(response.data.message);
                }
              }
            }
          }
        });
      });
    },

    setUpCredentials() {
      this.AWS.config.region = "us-west-2";
      this.AWS.config.credentials = new this.AWS.CognitoIdentityCredentials({
        IdentityPoolId: this.IdentityPoolData.DeveloperIdentityPoolId,
        Logins: {
          [this.IdentityPoolData.LoginARN]: this.IdToken
        }
      });
      this.cognitoidentityserviceprovider = new this.AWS.CognitoIdentityServiceProvider({
        apiVersion: "2016-04-18"
      });
    },

    createParamsUrl(paramsObject) {
      var paramsUrl = "";
      var counter = 0;
      var totalCount = Object.keys(paramsObject).length;
      for (var key in paramsObject) {
        if (paramsObject.hasOwnProperty(key)) {
          paramsUrl += key + "=" + paramsObject[key];
          if (counter != totalCount - 1) {
            paramsUrl += "&";
          }
          counter += 1;
        }
      }
      return paramsUrl.replace("#", "%23");
    }
  },

  created() {
    // on creation, set up the AWS credentials and get the master company list from the database.
    this.setUpCredentials();
    this.getMasterCompanyList();
  },

  beforeDestroy() {
    // before destroy, clear the cached identity.
    this.AWS.config.credentials.clearCachedId();
  }
};
</script>

<style lang="less" scoped>
.a-tab-pane {
  padding: 20px;
  overflow-x: auto;
}

.ant-form-item {
  margin-bottom: 5px;
}

.a-button {
  margin: 0 auto;
  display: block;
}
</style>
